<template>
  <div class="rename-wishlist-modal">
    <CustomModal :show="show"
                 @close="onClose">
      <template #header>
        <h1 class="custom-modal__heading">
          Rename wish list
        </h1>
      </template>
      <div class="rename-wishlist-modal__body">
        <div class="form-group">
          <input
            v-model="title"
            type="text"
            aria-label="Wish list name"
            placeholder="Wish list name"
            class="form-control rename-wishlist-modal__input">

          <span v-if="showValidation"
                class="warning-message">
            Please enter a valid wish list name
          </span>
        </div>

        <button
          class="btn btn-accent-1 rename-wishlist-modal__submit-button"
          :disabled="submitting || submitted"
          @click="onSubmit">
          <template v-if="submitting">
            <span class="visually-hidden">
              Renaming, please wait...
            </span>
            <font-awesome-icon icon="spinner"
                               spin></font-awesome-icon>
          </template>
          <template v-else-if="submitted">
            <span class="visually-hidden">
              Wishlist renamed
            </span>
            <font-awesome-icon icon="check"></font-awesome-icon>
          </template>
          <template v-else>
            Rename
          </template>
        </button>
      </div>
    </CustomModal>
  </div>
</template>

<script>
import CustomModal from "~/Components/CustomModal.vue";
import { renameWishlist } from "~/Scripts/resources/wishlistResource";

export default {
  name: "RenameWishlistModal",
  components: {
    CustomModal
  },
  props: {
    wishlistId: {
      type: String,
      default: null
    },
    originalTitle: {
      type: String,
      default: null
    },
    show: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      title: null,
      showValidation: false,
      submitting: false,
      submitted: false
    };
  },
  computed: {
    isValid () {
      let result = false;

      if ( this.title && this.title.trim().length > 0 ) {
        result = true;
      }

      return result;
    }
  },
  watch: {
    show ( val ) {
      if ( val ) {
        this.title = this.originalTitle;
        this.submitting = false;
        this.submitted = false;
        this.showValidation = false;
      }
    },
    originalTitle ( val ) {
      this.title = val;
    }
  },
  methods: {
    onSubmit () {
      if ( this.isValid ) {
        this.submitting = true;

        renameWishlist( this.wishlistId, this.title )
          .then( result => {
            if ( result && result.data ) {
              this.submitted = true;
              this.onClose();
            }
          } )
          .catch( error => {
            console.log( "error renaming wishlist", error );
            throw error;
          } )
          .finally( () => {
            this.submitting = false;
          } );
      } else {
        this.showValidation = true;
      }
    },
    onClose () {
      if ( this.submitted ) {
        this.$emit( "onClose", this.title );
      } else {
        this.$emit( "onClose" );
      }
    }
  }
};
</script>

<style lang="less" scoped>
.rename-wishlist-modal {
  .warning-message {
    color: #ed650b;
  }
}
</style>
